import { render, staticRenderFns } from "./worksRep.vue?vue&type=template&id=d6f27c7c"
import script from "./worksRep.vue?vue&type=script&lang=js"
export * from "./worksRep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports